import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Login as LoginIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';

const MotionPaper = motion(Paper);

const EmailConfirmed: React.FC = () => {
  useEffect(() => {
    // Show success message when component mounts
    toast.success('Email confirmed successfully! You can now sign in.');
  }, []);

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <MotionPaper
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          elevation={3}
          sx={{
            p: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: 100,
                color: 'success.main',
                mb: 3,
              }}
            />
          </motion.div>

          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Email Confirmed! ✅
          </Typography>

          <Typography variant="h6" color="text.secondary" sx={{ mb: 4, maxWidth: '600px' }}>
            Your email has been successfully verified. You can now sign in and start your personal development journey!
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 4 }}>
            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/login"
              startIcon={<LoginIcon />}
              sx={{
                background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #5a67d8 30%, #6b46c1 90%)',
                },
                minWidth: '200px',
                py: 1.5,
              }}
            >
              Sign In Now
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '500px' }}>
            Welcome to Health-Tree! Start building your personal development skills with our gamified talent tree system.
          </Typography>
        </MotionPaper>
      </Box>
    </Container>
  );
};

export default EmailConfirmed; 